<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" sm="12" md="2" class="text-right" style="margin-left: 81%">
          <b-button variant="primary" @click="pdfExport">
              {{  $t('globalTrans.export_pdf') }}
          </b-button>
      </b-col>
      <b-col lg="12" sm="12">
        <iq-card>
           <template v-slot:body>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.personal_info') }}
                  </h5>
                </div>
              </template>
              <b-table-simple bordered>
                    <b-tr>
                        <b-th>{{ $t('social_service.ofc_name') }}</b-th>
                        <b-td>{{getOfficeName(caseHistoryMain.office_id)}}</b-td>
                        <b-th>{{ $t('social_service.case_history_no') }}</b-th>
                        <b-td>{{$n(caseHistoryMain.case_history_no, { useGrouping: false })}}</b-td>
                        <b-th>{{ $t('social_service.pat_type') }}</b-th>
                        <b-td>
                          {{getPatientType(caseHistoryMain.patient_type)}}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.register_no') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{$n(caseHistoryMain.patient_reg_mains.hos_reg_no, { useGrouping: false })}}</b-td>
                        <b-th>{{ $t('social_service.patient_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.patient_name}}</b-td>
                        <b-th>{{ $t('social_service.patient_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.patient_name_bn}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.father_name_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.father_name}}</b-td>
                        <b-th>{{ $t('social_service.father_name_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.father_name_bn}}</b-td>
                        <b-th>{{ $t('social_service.mother_name_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.mother_name}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.mother_name_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.mother_name_bn}}</b-td>
                        <b-th>{{ $t('social_service.id_type') }}</b-th>
                        <b-td v-if="caseHistoryMain.id_type">{{getIdentityType(caseHistoryMain.id_type)}}</b-td>
                        <b-th>{{ $t('social_service.nid_no') }}</b-th>
                        <b-td>{{caseHistoryMain.id_no}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.form_no') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.form_no}}</b-td>
                        <b-th>{{ $t('social_service.patient_guar_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.guardian_name}}</b-td>
                        <b-th>{{ $t('social_service.patient_guar_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.guardian_name_bn}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.relation_patient_en') }}</b-th>
                        <b-td>{{caseHistoryMain.relation}}</b-td>
                        <b-th>{{ $t('social_service.relation_patient_bn') }}</b-th>
                        <b-td>{{caseHistoryMain.relation_bn}}</b-td>
                        <b-th>{{ $t('social_service.age') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{$n(caseHistoryMain.patient_reg_mains.age)}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.occupation_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.occupation}}</b-td>
                        <b-th>{{ $t('social_service.occupation_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.occupation_bn}}</b-td>
                        <b-th>{{ $t('social_service.monthly_income') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{$n(caseHistoryMain.patient_reg_mains.monthly_income)}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.mat_status') }}</b-th>
                        <b-td>{{getMeritalStatus(caseHistoryMain.marital_status)}}</b-td>
                        <b-th>{{ $t('social_service.edu_quali_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.qualification}}</b-td>
                        <b-th>{{ $t('social_service.edu_quali_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.qualification_bn}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.religion_en') }}</b-th>
                        <b-td>{{caseHistoryMain.religion}}</b-td>
                        <b-th>{{ $t('social_service.religion_bn') }}</b-th>
                        <b-td>{{caseHistoryMain.religion_bn}}</b-td>
                        <b-th>{{ $t('social_service.nationality_en') }}</b-th>
                        <b-td>{{caseHistoryMain.nationality}}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>{{ $t('social_service.nationality_bn') }}</b-th>
                      <b-td>{{caseHistoryMain.nationality_bn}}</b-td>
                      <b-td></b-td>
                      <b-td></b-td>
                      <b-td></b-td>
                      <b-td></b-td>
                    </b-tr>
              </b-table-simple>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('educational_management.present_business_address') }}
                  </h5>
                </div>
              </template>
              <b-table-simple bordered>
                <b-tr>
                  <b-th>{{$t('globalTrans.division')}}</b-th>
                  <b-td>{{getDivisionName(caseHistoryMain.pre_division_id)}}</b-td>
                  <b-th>{{$t('globalTrans.upazila')}}</b-th>
                  <b-td>{{getUpazillaName(caseHistoryMain.pre_upazilla_id)}}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{$t('globalTrans.district')}}</b-th>
                  <b-td>{{getDistrictName(caseHistoryMain.pre_district_id)}}</b-td>
                  <b-th> {{ $t('social_service.house_road_en') }} </b-th>
                  <b-td>{{caseHistoryMain.present_address}}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{$t('social_service.house_road_bn')}}</b-th>
                  <b-td>{{caseHistoryMain.present_address_bn}}</b-td>
                  <b-th> </b-th>
                  <b-td></b-td>
                </b-tr>
              </b-table-simple>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('educational_management.permanent_address') }}
                  </h5>
                </div>
              </template>
               <b-table-simple bordered>
                <b-tr>
                  <b-th>{{$t('globalTrans.division')}}</b-th>
                  <b-td>{{getDivisionName(caseHistoryMain.division_id)}}</b-td>
                  <b-th>{{$t('globalTrans.upazila')}}</b-th>
                  <b-td>{{getUpazillaName(caseHistoryMain.upazilla_id)}}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{$t('globalTrans.district')}}</b-th>
                  <b-td>{{getDistrictName(caseHistoryMain.district_id)}}</b-td>
                  <b-th> {{ $t('social_service.house_road_en') }} </b-th>
                  <b-td>{{caseHistoryMain.permanent_address}}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{$t('social_service.house_road_bn')}}</b-th>
                  <b-td>{{caseHistoryMain.permanent_address_bn}}</b-td>
                  <b-th> </b-th>
                  <b-td></b-td>
                </b-tr>
              </b-table-simple>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.patient_family_info') }}
                  </h5>
                </div>
              </template>
              <!-- <b-table-simple bordered>
                <b-tr>
                    <b-th>{{ $t('social_service.fam_mem_en') }}</b-th>
                    <b-td></b-td>
                    <b-th>{{ $t('social_service.fam_mem_bn') }}</b-th>
                    <b-td></b-td>
                    <b-th>{{ $t('social_service.age') }}</b-th>
                    <b-td></b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.gender') }}</b-th>
                    <b-td></b-td>
                    <b-th>{{ $t('social_service.edu_quali_en') }}</b-th>
                    <b-td></b-td>
                    <b-th>{{ $t('social_service.edu_quali_bn') }}</b-th>
                    <b-td></b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.occupation_en') }}</b-th>
                    <b-td></b-td>
                    <b-th>{{ $t('social_service.occupation_bn') }}</b-th>
                    <b-td></b-td>
                    <b-th>{{ $t('social_service.monthly_income') }}</b-th>
                    <b-td></b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.religion_en') }}</b-th>
                    <b-td></b-td>
                    <b-th>{{ $t('social_service.religion_bn') }}</b-th>
                    <b-td></b-td>
                    <b-th>{{ $t('social_service.coment_en') }}</b-th>
                    <b-td></b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.coment_en') }}</b-th>
                    <b-td></b-td>
                    <b-th></b-th>
                    <b-td></b-td>
                    <b-th></b-th>
                    <b-td></b-td>
                </b-tr>
              </b-table-simple> -->
                <b-table-simple bordered>
                  <tr>
                    <th>{{$t('globalTrans.sl_no')}}</th>
                    <th>{{$t('social_service.fam_mem_en')}}</th>
                    <th>{{$t('social_service.age')}}</th>
                    <th>{{$t('social_service.gender')}}</th>
                    <th>{{$t('social_service.occupation_en')}}</th>
                  </tr>
                  <template v-for="(family, index) in caseHistoryMain.casehistory_family_members">
                    <b-tr :key="family.id">
                      <b-td>{{$n(index + 1)}}</b-td>
                      <b-td>{{family.member_name}}</b-td>
                      <b-td>{{ $n(family.age) }}</b-td>
                      <b-td>{{getGender(family.gender)}}</b-td>
                      <b-td>{{family.occupation}}</b-td>
                    </b-tr>
                  </template>
                </b-table-simple>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.admiss') }}
                  </h5>
                </div>
              </template>
              <b-table-simple bordered>
                    <b-tr>
                        <b-th>{{ $t('social_service.register_no') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{$n(caseHistoryMain.patient_reg_mains.hos_reg_no, { useGrouping: false })}}</b-td>
                        <b-th>{{ $t('social_service.hos_dept') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{getDepartmentName(caseHistoryMain.patient_reg_mains.department_id)}}</b-td>
                        <b-th>{{ $t('social_service.ward_no') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{getWardName(caseHistoryMain.patient_reg_mains.hos_ward_id)}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.bed_no') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.hos_bed_id}}</b-td>
                        <b-th>{{ $t('social_service.dises_name_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.patient_situation}}</b-td>
                        <b-th>{{ $t('social_service.dises_name_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.patient_situation_bn}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.wight') }}</b-th>
                        <b-td>{{caseHistoryMain.weight}}</b-td>
                        <b-th>{{ $t('social_service.blood_en') }}</b-th>
                        <b-td>{{caseHistoryMain.blood_group}}</b-td>
                        <b-th>{{ $t('social_service.blood_bn') }}</b-th>
                        <b-td>{{caseHistoryMain.blood_group_bn}}</b-td>
                    </b-tr>
                    <!-- <b-tr>
                        <b-th>{{ $t('social_service.related_docu_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.hos_reg_no}}</b-td>
                        <b-th>{{ $t('social_service.related_docu_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.hos_reg_no}}</b-td>
                        <b-th>{{ $t('social_service.upload') }}</b-th>
                        <b-td v-if="caseHistoryMain.patient_reg_mains">{{caseHistoryMain.patient_reg_mains.hos_reg_no}}</b-td>
                    </b-tr> -->
              </b-table-simple>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.docu') }}
                  </h5>
                </div>
              </template>
                <b-table-simple bordered>
                  <tr>
                    <th>{{$t('globalTrans.sl_no')}}</th>
                    <th>{{$t('social_service.related_docu_en')}}</th>
                    <th>{{$t('social_service.related_docu_bn')}}</th>
                    <th>{{$t('social_service.upload')}}</th>
                  </tr>
                  <template v-for="(document, index) in caseHistoryMain.casehistory_docs">
                    <b-tr :key="document.id">
                      <b-td>{{$n(index + 1)}}</b-td>
                      <b-td>{{document.document_title}}</b-td>
                      <b-td>{{document.document_title_bn}}</b-td>
                      <b-td>
                        <a :href="hospitalServiceBaseUrl + 'download-attachment?file=' + document.attachment" target="_blank" v-if="document.id > 0">
                          {{ document.attachment.split('/').pop() }}
                          <i class="ri-download-cloud-line" ></i>
                        </a>
                      </b-td>
                    </b-tr>
                  </template>
                </b-table-simple>
               <!-- <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.admiss') }}
                  </h5>
                </div>
              </template> -->
              <b-table-simple bordered>
                    <b-tr>
                        <b-th>{{ $t('social_service.regular_checkup_en') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.regular)}}
                          <br>{{ $t('social_service.comment') }}:
                          {{caseHistoryMain.casehistory_others.regular_comment}}

                        </b-td>
                        <b-th>{{ $t('social_service.regular_checkup_bn') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.regular)}}
                          <br>{{ $t('social_service.comment') }}:
                          {{caseHistoryMain.casehistory_others.regular_comment_bn}}
                        </b-td>
                        <b-th>{{ $t('social_service.vaccination') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.vaccination)}}
                          <br>{{ $t('social_service.comment') }}:
                          <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_others.vaccination_comment}}</span>
                          <span v-else>{{caseHistoryMain.casehistory_others.vaccination_comment_bn}}</span>
                          </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.food_all') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.food)}}
                          <br>{{ $t('social_service.comment') }}:
                          <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_others.food_comment}}</span>
                          <span v-else>{{caseHistoryMain.casehistory_others.food_comment_bn}}</span>
                        </b-td>
                        <b-th>{{ $t('social_service.smoking') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.smoking)}}
                          <br>{{ $t('social_service.comment') }}:
                          <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_others.smoking_comment}}</span>
                          <span v-else>{{caseHistoryMain.casehistory_others.smoking_comment_bn}}</span>
                        </b-td>
                        <b-th>{{ $t('social_service.phy_dis') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.physical)}}
                          <br>{{ $t('social_service.comment') }}:
                          <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_others.physical_comment}}</span>
                          <span v-else>{{caseHistoryMain.casehistory_others.physical_comment_bn}}</span>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.tak_med_adv') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.medicine)}}
                          <br>{{ $t('social_service.comment') }}:
                          <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_others.medicine_comment}}</span>
                          <span v-else>{{caseHistoryMain.casehistory_others.medicine_comment_bn}}</span>
                        </b-td>
                        <b-th>{{ $t('social_service.other_dises') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.other_disease)}}
                          <br>{{ $t('social_service.comment') }}:
                          <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_others.other_disease_comment}}</span>
                          <span v-else>{{caseHistoryMain.casehistory_others.other_disease_comment_bn}}</span>
                        </b-td>
                        <b-th>{{ $t('social_service.familly_his_dis') }}</b-th>
                        <b-td v-if="caseHistoryMain.casehistory_others">
                          {{getAnswer(caseHistoryMain.casehistory_others.family_history)}}
                          <br>{{ $t('social_service.comment') }}:
                          <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_others.family_history_comment}}</span>
                          <span v-else>{{caseHistoryMain.casehistory_others.family_history_comment_bn}}</span>
                        </b-td>
                    </b-tr>
              </b-table-simple>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.pat_social') }}
                  </h5>
                </div>
              </template>
              <b-table-simple bordered>
                <b-tr>
                    <b-th>{{ $t('social_service.personal_home') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.personal)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.personal_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.personal_comment_bn}}</span>
                    </b-td>
                    <b-th>{{ $t('social_service.affec_geo_posi') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.affected)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.affected_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.affected_comment_bn}}</span>
                    </b-td>
                    <b-th>{{ $t('social_service.jakat_eli') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.jakat)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.jakat_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.jakat_comment_bn}}</span>
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.vill_cen_life') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.village_centric)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.village_centric_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.village_centric_comment_bn}}</span>
                    </b-td>
                    <b-th>{{ $t('social_service.city_center_life') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.city_centric)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.city_centric_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.city_centric_comment_bn}}</span>
                    </b-td>
                    <b-th>{{ $t('social_service.prv_serv_from_hos') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.prev_hos)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.prev_hos_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.prev_hos_comment_bn}}</span>
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.prv_serv_other_hos') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.prev_other_hos)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.prev_other_hos_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.prev_other_hos_comment_bn}}</span>
                    </b-td>
                    <b-th>{{ $t('social_service.regu_serv_take_dss') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.reg_dss)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.reg_dss_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.reg_dss_comment_bn}}</span>
                    </b-td>
                    <b-th>{{ $t('social_service.pat_eli_fin_help') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_socio">
                      {{getAnswer(caseHistoryMain.casehistory_socio.pat_eligibility)}}
                      <br>{{ $t('social_service.comment') }}:
                      <span v-if="lang === 'en'">{{caseHistoryMain.casehistory_socio.pat_eligibility_comment}}</span>
                      <span v-else>{{caseHistoryMain.casehistory_socio.pat_eligibility_comment_bn}}</span>
                    </b-td>
                </b-tr>
              </b-table-simple>
              <b-table-simple bordered>
                <b-tr>
                    <b-th>{{ $t('social_service.medi_assis_ofc') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{getMedAssistace(caseHistoryMain.casehistory_med_assistance.assistance_type_id)}}</b-td>
                    <b-th>{{ $t('social_service.rehabil_desc_par_en') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.rehab_description}}</b-td>
                    <b-th>{{ $t('social_service.rehabil_desc_par_bn') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.rehab_description_bn}}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.cash_recv_en') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.receiver_name}}</b-td>
                    <b-th>{{ $t('social_service.cash_recv_bn') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.receiver_name_bn}}</b-td>
                    <b-th>{{ $t('social_service.case_rec_des_en') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.designation}}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.case_rec_des_bn') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.designation_bn}}</b-td>
                    <b-th>{{ $t('social_service.related_officer_name_en') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.officer_name}}</b-td>
                    <b-th>{{ $t('social_service.related_officer_name_bn') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.officer_name_bn}}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('social_service.related_officer_comment_en') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.comments}}</b-td>
                    <b-th>{{ $t('social_service.related_officer_comment_bn') }}</b-th>
                    <b-td v-if="caseHistoryMain.casehistory_med_assistance">{{caseHistoryMain.casehistory_med_assistance.comments_bn}}</b-td>
                    <b-th></b-th>
                    <b-td></b-td>
                </b-tr>
              </b-table-simple>
              <!-- <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.ac_tk_p_impr_c_s') }}
                  </h5>
                </div>
              </template>
                <b-table-simple bordered>
                  <tr>
                    <th>{{$t('social_service.action_taken_en')}}</th>
                    <th>{{$t('social_service.action_taken_bn')}}</th>
                    <th>{{$t('social_service.follow_prograss_situation_en')}}</th>
                    <th>{{$t('social_service.follow_prograss_situation_bn')}}</th>
                  </tr>
                  <b-tr>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                  </b-tr>
                </b-table-simple> -->
                <!-- <template>
                    <div style="font-size:18px; background-color: #005B5B;">
                        <h5 class="text-white text-center"> {{ $t('social_service.other_information') }}
                        </h5>
                    </div>
                </template>
                <b-table-simple bordered>
                    <b-tr>
                        <b-th>{{ $t('social_service.other_relavant_en') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.other_relavant_bn') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.comment_patient_en') }}</b-th>
                        <b-td></b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.comment_patient_bn') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.comment_guardian_en') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.comment_guardian_bn') }}</b-th>
                        <b-td></b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.supporting_authority_en') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.supporting_authority_bn') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.comment_welfare_en') }}</b-th>
                        <b-td></b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.comment_welfare_bn') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.recomnd_patient_en') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.recomnd_patient_bn') }}</b-th>
                        <b-td></b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.case_close_date') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.follow_ofc_name_en') }}</b-th>
                        <b-td></b-td>
                        <b-th>{{ $t('social_service.follow_ofc_name_bn') }}</b-th>
                        <b-td></b-td>
                    </b-tr>
                </b-table-simple>
                <template>
                    <div style="font-size:18px; background-color: #005B5B;">
                        <h5 class="text-white text-center">
                            {{ $t('social_service.relevent_document_upload') }}
                        </h5>
                    </div>
                </template>
                <b-table-simple bordered>
                  <tr>
                    <th>{{$t('social_service.document_name_en')}}</th>
                    <th>{{$t('social_service.document_name_bn')}}</th>
                    <th>{{$t('social_service.upload')}}</th>
                  </tr>
                  <b-tr>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                  </b-tr>
                </b-table-simple> -->
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { caseHistoryMainStore, caseHistoryMainUpdate } from '../../../api/routes'
import ExportPdf from './export-pdf_details'

export default {
  props: ['id'],
  components: {
  },
  created () {
    if (this.id) {
      const tmp = this.getCaseHistoryData()
      this.caseHistoryMain = tmp
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      hospitalServiceBaseUrl: hospitalServiceBaseUrl,
      test: 0,
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      perShowData: 0,
      lang: this.$i18n.locale,
      showData: 0,
      caseHistoryMain: {
        area_type_id: '',
        attachment: '',
        blood_group: '',
        blood_group_bn: '',
        case_history_no: '',
        casehistory_docs: {},
        city_corporation_id: '',
        country_id: '',
        created_at: '',
        created_by: '',
        disease: '',
        disease_bn: '',
        district_id: '',
        division_id: '',
        form_no: '',
        hospital_id: '',
        id: '',
        id_no: '',
        id_type: '',
        is_verified: '',
        marital_status: '',
        nationality: '',
        nationality_bn: '',
        office_id: '',
        patient_name: '',
        patient_name_bn: '',
        patient_reg_mains: {
          address: '',
          address_bn: '',
          admission_type: '',
          age: '',
          area_type_id: '',
          attachment: '',
          city_corporation_id: '',
          country_id: '',
          created_at: '',
          created_by: '',
          delivery_date: '',
          delivery_status: '',
          delivery_type: '',
          department_id: '',
          district_id: '',
          division_id: '',
          doctor_name: '',
          doctor_name_bn: '',
          father_name: '',
          father_name_bn: '',
          form_no: '',
          gender_id: '',
          guardian_mobile_no: '',
          guardian_name: '',
          guardian_name_bn: '',
          hos_bed_id: '',
          hos_reg_date: '',
          hos_reg_no: 0,
          hos_ward_id: '',
          hospital_id: '',
          id: '',
          monthly_income: '',
          mother_name: '',
          mother_name_bn: '',
          occupation: '',
          occupation_bn: '',
          patient_name: '',
          patient_name_bn: '',
          patient_situation: '',
          patient_situation_bn: '',
          pauroshoba_id: '',
          phone_no: '',
          reg_date: '',
          so_officer_comment: '',
          so_officer_comment_bn: '',
          status: '',
          union_id: '',
          upazilla_id: '',
          updated_at: '',
          updated_by: '',
          ward_id: ''
        },
        patient_type: '',
        pauroshoba_id: '',
        permanent_address: '',
        permanent_address_bn: '',
        pre_area_type_id: '',
        pre_city_corporation_id: '',
        pre_country_id: '',
        pre_district_id: '',
        pre_division_id: '',
        pre_pauroshoba_id: '',
        pre_thana_id: '',
        pre_union_id: '',
        pre_upazilla_id: '',
        pre_ward_id: '',
        present_address: '',
        present_address_bn: '',
        qualification: '',
        qualification_bn: '',
        related_document: '',
        related_document_bn: '',
        relation: '',
        relation_bn: '',
        religion: '',
        religion_bn: '',
        status: '',
        thana_id: '',
        union_id: '',
        upazilla_id: '',
        updated_at: '',
        updated_by: '',
        ward_id: '',
        weight: ''
      }
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getCaseHistoryData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    getPatientType: function (type) {
      return this.$store.state.HospitalDisabilityService.commonObj.patientTypeList.find(t => t.value === type).text
    },
    getIdentityType: function (type) {
      return this.$store.state.HospitalDisabilityService.commonObj.identityTypeList.find(t => t.value === type).text
    },
    getMeritalStatus (type) {
      return this.$store.state.commonObj.maritalStatus.find(t => t.value === type).text
    },
    getGender (type) {
      if (this.lang === 'en') {
        if (type === 1) {
          return 'Male'
        }
        return 'Female'
      } else {
        if (type === 1) {
          return 'পুরুষ'
        }
        return 'মহিলা'
      }
    },
    getAnswer (type) {
      if (this.lang === 'en') {
        if (type === 1) {
          return 'Yes'
        }
        return 'No'
      } else {
        if (type === 1) {
          return 'হ্যাঁ'
        }
        return 'না'
      }
    },
    getMedAssistace (type) {
      if (type === 1) {
        return this.$t('social_service.financial')
      }
      if (type === 2) {
        return this.$t('social_service.mentally')
      }
      if (type === 3) {
        return this.$t('social_service.material')
      }
    },
    getPatientName () {
      if (this.caseHistoryMain) {
        if (this.lang === 'en') {
          return this.caseHistoryMain.patient_reg_mains.patient_name
        } else {
          return this.caseHistoryMain.patient_reg_mains.patient_name_bn
        }
      }
    },
    getOfficeName (id) {
      if (id) {
        return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(hospital => hospital.value === id)[0].text
      }
    },
    getDepartmentName (id) {
      if (id) {
        return this.$store.state.HospitalDisabilityService.commonObj.deptList.filter(dept => dept.value === id)[0].text
      }
    },
    getWardName (id) {
      if (id) {
        return this.$store.state.HospitalDisabilityService.commonObj.hosWardList.filter(ward => ward.value === id)[0].text
      }
    },
    getDivisionName (id) {
      if (id) {
        return this.$store.state.commonObj.divisionList.filter(item => item.value === id)[0].text
      }
    },
    getDistrictName (id) {
      if (id) {
        return this.$store.state.commonObj.districtList.filter(district => district.value === id)[0].text
      }
    },
    getUpazillaName (id) {
      if (id) {
        return this.$store.state.commonObj.upazilaList.filter(upazila => upazila.value === id)[0].text
      }
    },
    async register () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadinState = { loading: false, listReload: true }
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      var formData = new FormData()
      Object.keys(this.caseHistoryMain).map(key => {
        if (key === 'pay_order_attachment') {
          formData.append(key, this.pay_order_attachment)
        }
        if (key === 'photo') {
          formData.append(key, this.photo)
        } else {
          formData.append(key, this.caseHistoryMain[key])
        }
      })

      if (this.caseHistoryMain.id) {
        formData.append('_method', 'POST')
        result = await RestApi.postData(hospitalServiceBaseUrl, `${caseHistoryMainUpdate}/${this.id}`, formData, config)
      } else {
        result = await RestApi.postData(hospitalServiceBaseUrl, caseHistoryMainStore, formData, config)
      }
      this.$store.dispatch('mutateCommonProperties', loadinState)

      if (result.success) {
        this.$store.dispatch('SeedsFertilizer/mutateCommonObj', { hasDropdownLoaded: false })
        this.$toast.success({
          title: 'Success',
          message: this.id ? 'Data updated successfully' : 'Data save successfully',
          color: '#D6E09B'
        })

        this.$bvModal.hide('modal-4')
      } else {
        this.$refs.form.setErrors(result.errors)
        this.$toast.error({
          title: 'Error',
          message: 'Operation failed! Please, try again.'
        })
      }
    },
    pdfExport () {
      const reportTitle = this.$t('report.case_history_details_report')
      ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.caseHistoryMain, this)
    }
  }
}
</script>
